import Vue from 'vue'
import parseErrors from './parseErrors'

export default e => {
  const errors = parseErrors(e)

  errors.forEach(error => {
    Vue.toaster.error(error)
  })
}
